export const getPlay = state => state.getIn(['chat', 'sound', 'play'], false);
